import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AutenticacionService } from './autenticacion.service';
import { SharedService } from './shared.service';

export const ICONO_FAMILIA_BLANCO = 'assets/images/header/iconos/limpieza_blanco.png';
export const ICONO_FAMILIA_AZUL = 'assets/images/header/iconos/limpieza_azul.png';

export const FAMILIAS_FALLBACK = [
  { texto: 'Limpieza', img1: 'assets/images/header/iconos/limpieza_blanco.png', img2: 'assets/images/header/iconos/limpieza_azul.png', destacada: 0, orden_menu: 1, links: [] },
  { texto: 'Bazar', img1: 'assets/images/header/iconos/bazar_blanco.png', img2: 'assets/images/header/iconos/bazar_azul.png', destacada: 0, orden_menu: 2, links: [] },
  { texto: 'Textil', img1: 'assets/images/header/iconos/textil_blanco.png', img2: 'assets/images/header/iconos/textil_azul.png', destacada: 0, orden_menu: 3, links: [] },
  { texto: 'Liquidos', img1: 'assets/images/header/iconos/liquidos_blanco.png', img2: 'assets/images/header/iconos/liquidos_azul.png', destacada: 0, orden_menu: 4, links: [] },
  { texto: 'Jardin y riego', img1: 'assets/images/header/iconos/jardin_blanco.png', img2: 'assets/images/header/iconos/jardin_azul.png', destacada: 0, orden_menu: 5, links: [] },
  { texto: 'Profesional', img1: 'assets/images/header/iconos/electro_blanco.png', img2: 'assets/images/header/iconos/electro_azul.png', destacada: 0, orden_menu: 6, links: [] },
  { texto: 'Mas productos', img1: 'assets/images/header/iconos/perfumeria_blanco.png', img2: 'assets/images/header/iconos/perfumeria_azul.png', destacada: 0, orden_menu: 7, links: [] },
];

export function iconoFamiliaFallback(event: Event) {
  const img = event.target as HTMLImageElement;
  if (!img || img.dataset.fallback === '1') {
    return;
  }
  const esperado = img.getAttribute('data-src') || '';
  const intento = img.currentSrc || img.src || '';
  if (!esperado || intento.indexOf(esperado) === -1) {
    return;
  }
  img.dataset.fallback = '1';
  img.src = esperado.indexOf('_blanco') !== -1 ? ICONO_FAMILIA_BLANCO : ICONO_FAMILIA_AZUL;
}

export function normalizarFamilia(texto: string): string {
  return (texto || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ñ/g, 'n')
    .trim();
}

function slugIcono(nombre: string): string {
  return normalizarFamilia(nombre).replace(/\s+/g, '-');
}

function iconosDe(nombre: string): { img1: string, img2: string } {
  const legacy = FAMILIAS_FALLBACK.find((familia) => familia.texto === nombre);
  if (legacy) {
    return { img1: legacy.img1, img2: legacy.img2 };
  }
  const slug = slugIcono(nombre);
  return {
    img1: `assets/images/header/iconos/${slug}_blanco.png`,
    img2: `assets/images/header/iconos/${slug}_azul.png`,
  };
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();

  public catImagenesList: any = [];
  public secImagenesList: any = [];

  public LinkList: any[] = [];
  private linkListSubject = new BehaviorSubject<any[]>([]);
  public LinkList$ = this.linkListSubject.asObservable();

  private MenuListSubject = new Subject<any>();
  public MenuList$ = this.MenuListSubject.asObservable();

  constructor(private http: HttpClient, private auth: AutenticacionService, private data: SharedService) {
    this.http.get(this.auth.getPath('public/producto/categorias/getAll')).subscribe({
      next: ($response: any) => {
        const cuerpo = $response && $response['response'] ? $response['response'] : {};
        const familias = Array.isArray(cuerpo['familias']) ? cuerpo['familias'] : null;
        if (!familias) {
          this.publicar(this.copiarFallback());
          return;
        }
        const listado = familias
          .filter((familia: any) => familia && familia.nombre && Number(familia.visible_menu) === 1)
          .map((familia: any) => this.armarFamilia(familia, cuerpo[familia.nombre]));
        this.publicar(listado.length ? listado : this.copiarFallback());
        if (cuerpo['imagenes_secciones']) {
          this.secImagenesList = cuerpo['imagenes_secciones'];
        }
      },
      error: ($error: any) => {
        this.data.log('getallcategorias header error menu: ', $error);
        this.publicar(this.copiarFallback());
      }
    });
  }

  public familiaPorBusqueda(texto: string): string | null {
    const buscado = normalizarFamilia(texto);
    const familia = this.LinkList.find((item) => normalizarFamilia(item.texto) === buscado);
    return familia ? familia.texto : null;
  }

  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

  private publicar(listado: any[]) {
    this.LinkList = listado;
    this.linkListSubject.next(listado);
  }

  private copiarFallback() {
    return FAMILIAS_FALLBACK.map((familia) => ({ ...familia, links: [] }));
  }

  private armarFamilia(familia: any, linksApi: any) {
    const iconos = iconosDe(familia.nombre);
    const categorias: any[] = [];
    if (linksApi) {
      for (const subLink in linksApi) {
        if (!linksApi.hasOwnProperty(subLink)) {
          continue;
        }
        const subcategoria = linksApi[subLink];
        subcategoria['padre'] = { nombre: subLink, id: subcategoria.id };
        const indice = categorias.push({
          show: false,
          head: { texto: subcategoria.padre.nombre, link: this.convertLink(subcategoria.padre) },
          items: []
        }) - 1;
        if (subcategoria.categoriasHijas) {
          for (const hija in subcategoria.categoriasHijas) {
            if (!subcategoria.categoriasHijas.hasOwnProperty(hija)) {
              continue;
            }
            const categoriaHija = subcategoria.categoriasHijas[hija];
            if (categoriaHija.nombre) {
              categorias[indice].items.push({ texto: categoriaHija.nombre, link: this.convertLink2(subcategoria.padre, categoriaHija) });
            } else {
              this.data.log('getallcategorias categoria hija sin nombre menu:', categoriaHija);
            }
          }
        }
      }
    }
    if (familia.url_imagen) {
      this.catImagenesList[familia.nombre] = familia.url_imagen;
    }
    return {
      texto: familia.nombre,
      img1: iconos.img1,
      img2: iconos.img2,
      destacada: Number(familia.destacada) === 1,
      orden_menu: Number(familia.orden_menu) || 100,
      url_imagen: familia.url_imagen || '',
      links: categorias,
    };
  }

  convertLink = ($subcategoria: any) => {
    try {
      const texto = $subcategoria.nombre.split(' ').join('-') + '/' + $subcategoria.id;
      return texto;
    } catch ($error) {
      this.data.log('convertirlink Alguno de los datos de la subcategoria esta incompleto menu');
      return '';
    }
  }
  convertLink2 = ($categoria: any, $subcategoria: any) => {
    try {
      const texto = $categoria.nombre.split(' ').join('-') + '/' +  $subcategoria.nombre.split(' ').join('-') + '/' + $subcategoria.id;
      return texto;
    } catch ($error) {
      this.data.log('convertirlink2 Alguno de los datos de la subcategoria esta incompleto menu');
      return '';
    }
  }
}
